/**
 * The EventBus topic a page uses to drive a PlatformTable's full-text search.
 *
 * ITS OWN MODULE SO THERE IS ONE SPELLING. The page emitting and the table listening are at
 * opposite ends of the tree and share nothing else; a topic string written out twice is a feature
 * that silently does nothing, because an emit with no listener is not an error.
 *
 * KEYED ON THE LIST'S ENTERPRISE COMPONENT, which is the one object both ends hold: the page makes
 * it and hands it to the applet. The component the table searches with is private to the table.
 */
export const fullTextTopic = (enterpriseComponent: any): string =>
    `${enterpriseComponent?.serialNumber}-platform-table-full-text`;
